await import('/home/ubuntu/yanglao/carehome-demo/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('/home/ubuntu/yanglao/carehome-demo/src/.umi/umi.ts');
export default 1;